import { Suspense } from 'react';
import { RouterProvider } from 'react-router';
import DocumentTitle from 'react-document-title';
import { ApolloProvider } from '@apollo/client';
import apolloClient from 'apolloClient';

import '../i18n';
import * as Core from './core';
import ShowInitialNotifications from './ShowInitialNotifications';
import LoadScripts from './LoadScripts';
import { router } from 'client/routes';

export function Application() {
  return (
    <Core.ErrorBoundary>
      <DocumentTitle title="Kilotype">
        <ApolloProvider client={apolloClient}>
          <Suspense fallback={<Core.Loader fullPage />}>
            <RouterProvider router={router} />
          </Suspense>

          <LoadScripts />

          <ShowInitialNotifications />
        </ApolloProvider>
      </DocumentTitle>
    </Core.ErrorBoundary>
  );
}

Application.displayName = 'Application';

export default Application;
